import type {
  SysDeptMutation,
  SysDeptTreeNode,
  SysStaffItem,
  SysStaffListFilters,
  SysStaffMutation,
} from "../types";

export type SysDeptOption = {
  label: string;
  value: number;
};

export type SysStaffOption = {
  label: string;
  searchText: string;
  value: number;
};

/** 创建空部门表单。 */
export function createEmptySysDeptMutation(parentId = 0): SysDeptMutation {
  return {
    deptName: "",
    parentId,
    orderNum: 0,
    leaderId: undefined,
    approverId: undefined,
    phone: "",
    email: "",
    status: 1,
  };
}

/** 创建空用户表单。 */
export function createEmptySysStaffMutation(selectedDeptId?: number): SysStaffMutation {
  return {
    username: "",
    realname: "",
    nickname: "",
    phone: "",
    email: "",
    avatar: "",
    sex: 2,
    mainDeptId: selectedDeptId,
    deptIds: selectedDeptId ? [selectedDeptId] : [],
    status: 1,
    userType: 1,
    supplierId: undefined,
    wxOpenid: "",
    wxUnionid: "",
    isSubscribe: false,
    isSuperuser: false,
    isStaff: Boolean(selectedDeptId),
    supervisors: [],
  };
}

/** 归一化用户筛选条件。 */
export function normalizeSysStaffFilters(filters: SysStaffListFilters): SysStaffListFilters {
  return {
    keyword: normalizeOptionalText(filters.keyword),
    phone: normalizeOptionalText(filters.phone),
    isStaff: filters.isStaff,
  };
}

/** 将部门树拍平成下拉选项。 */
export function flattenSysDeptOptions(nodes: SysDeptTreeNode[]): SysDeptOption[] {
  const result: SysDeptOption[] = [];

  /** 递归访问部门树节点。 */
  function visit(items: SysDeptTreeNode[], depth: number) {
    for (const item of items) {
      result.push({
        value: item.id,
        label: `${"　".repeat(depth)}${item.deptName}`,
      });
      visit(item.children, depth + 1);
    }
  }

  visit(nodes, 0);
  return result;
}

/** 将用户列表转换为人员选择选项。 */
export function flattenSysStaffOptions(items: SysStaffItem[]): SysStaffOption[] {
  return items.map((item) => ({
    value: item.id,
    label: formatSysStaffOptionLabel(item),
    searchText: [
      item.realname,
      item.nickname,
      item.username,
      item.phone,
      item.email,
      String(item.id),
    ]
      .filter(Boolean)
      .join(" "),
  }));
}

/** 生成人员选择中的展示名称。 */
export function formatSysStaffOptionLabel(item: SysStaffItem): string {
  const name = item.realname || item.nickname || item.username;
  return name === item.username ? item.username : `${name} ${item.username}`;
}

/** 归一化可选文本。 */
function normalizeOptionalText(value?: string) {
  const normalized = value?.trim();
  return normalized ? normalized : undefined;
}
